import React, {useState, useEffect, useRef} from 'react';
import useInterval from '../../../../customHooks/useInterval';

const TrainEvent = props => {
    const [eventActive, setEventActive] = useState(false);
    const [eventOver, setEventOver] = useState(false);
    
    const [trainDistance, setTrainDistance] = useState(0);
    const [activeTrainData, setActiveTrainData] = useState();

    const ANIMATION_FRAMERATE = 1000 / 60;
    
    const [animationTime, setAnimationTime] = useState(0)
    const [animationFramerate, setAnimationFramerate] = useState(null);

    const previousAnimationTime = React.useRef(0);
    
    const [activeAudioList, setActiveAudioList] = useState([])

    const styleObject = {
        transform: `translate3d(${
            props.xOffset - trainDistance
        }%, ${
            props.yOffset
        }%, ${
            props.zOffset
        }px) scalex(${activeTrainData?.trainStartDirection === 'left'?-1:1})`,
        zIndex: props.zIndex
    }
    console.log("trainDistance:",trainDistance)
    
    useInterval(() => {
        if (eventActive && !eventOver) {  // train is still active, and the event is not over
            setAnimationTime(animationTime + animationFramerate)
            if (animationTime < props.data?.animationTimeout) {

                const eventsToProcess = props.data.timedEvents.filter((e) => {
                    return e.time > previousAnimationTime.current && e.time <= animationTime;
                    
                })
                eventsToProcess.forEach(e => {
                    console.log("Dispatching Events", e)
                    switch (e.event) {
                        case 'window':
                            
                          //props.setSideTrainVisible(e.train);
                          //  props.setSideTrainVisible(e.translation==='none' ? null : e.translation)
                            
                            if (e.side === 'left'){
                                props.setLeftSideView(e.value==='' ? null : e.value)
                            }
                            if (e.side === 'right'){
                                props.setRightSideView(e.value==='' ? null : e.value)
                            }
                            break;
                        case 'road':
                            props.updateRoad(e.value)
                            if (props.data.silentCrossing === false) {
                                props.audioController.removeAudio("longLongShortLongHorn")
                            }
                            break;
                        case 'startAudio':
                            startAudio(e.value)
                            break;
                        case 'endAudio':
                            stopAudio(e.value)
                            break;
                        case 'flash_crossing_lights':
                            props.updateRoad(e.value === true ? 'startAnimateCrossing' : 'stopAnimatedCrossing')

                            console.log("Flash Crossing Lights: ", e.value, props)
                            break
                        case 'internal':
                            // TODO: need to handle train events
                            setActiveTrainData({...e.data, startTime:animationTime})
                            break
                        default:
                            break;
                    }
                })
                if (activeTrainData) {
                    const endTime = activeTrainData.startTime + activeTrainData.trainDuration
                    if (activeTrainData?.trainStartDirection === 'left'){
                        //left train
                        if (animationTime > activeTrainData.startTime+activeTrainData.trainDuration){
                            setActiveTrainData(undefined)
                        } else {
                            const currentTrainTime = (activeTrainData.startTime+activeTrainData.trainDuration)-animationTime
                            const percentTrainTime = currentTrainTime/activeTrainData.trainDuration
                            const pxOffset = percentTrainTime*activeTrainData.finishPosition
                            setTrainDistance(pxOffset)
                        }
                    } else {
                        //right train
                        if (animationTime > activeTrainData.startTime+activeTrainData.trainDuration){
                            setActiveTrainData(undefined)
                        } else {
                            const currentTrainTime = animationTime-activeTrainData.startTime
                            const percentTrainTime = currentTrainTime/activeTrainData.trainDuration
                            const pxOffset = percentTrainTime*activeTrainData.finishPosition
                            setTrainDistance(pxOffset)
                        }
                    }
                }

            } else {
                setAnimationFramerate(null) // Stop the interval
                activeAudioList.forEach(e => {
                    props.audioController.removeAudio(e); // remove all active audios
                })
                setActiveAudioList([]) // reset the active audio list

                setEventActive(false) // check to see if these are needed
                setEventOver(true);


                setTimeout(() => { // this should be handled with Data
                    props.setSideTrainVisible(null);
                    props.audioController.removeAudio('crossing1_3_train');
                }, 3000)

                // add event to the completed events
                props.setCompletedRoadEvents((state) => {
                        const newCompletedEvents = [...state];
                        newCompletedEvents[props.data.eventId] = true;
                        return newCompletedEvents
                    }
                )

                props.audioController.removeAudio('crossing_bells'); // I don't think this should be needed any more.

            }
            previousAnimationTime.current = animationTime;
        }
           
         return () => {
            return
         }
     }, animationFramerate)



    useEffect(() => {
        if (props.didStopCorrectly) {
            if(props.delay){
                const trainTimeout = setTimeout(() => {
                    startAnimation()
                }, (props.delay * 1000));
                // clear timeout before unmount
                return () => clearTimeout(trainTimeout)
            }else{
                setAnimationFramerate(ANIMATION_FRAMERATE)
                setEventActive(true);
            }
        }
    }, [props.didStopCorrectly])



    useEffect(() => {
        return () => {
            // remove any audio that might be playing.
            activeAudioList.forEach(e=>{ 
                props.audioController.removeAudio(e); // remove all active audios
            })
            props.audioController.removeAudio('crossing1_3_train');
            props.audioController.removeAudio('crossing_bells');
        }
    }, [])

    const startAudio = (audioName) => {
        props.audioController.playAudioByName(audioName);
        setActiveAudioList((list)=>{
            if (list.indexOf(audioName) === -1){
                return ([...list, audioName])
            } 
            return list
        })       
    }
    const stopAudio = (audioName) => {
        props.audioController.removeAudio(audioName);
        setActiveAudioList((list)=>{
            if (list.indexOf(audioName) !== -1){
                return ([...list].splice(list.indexOf(audioName),1))
            } 
            return list
        })       
    }

    const startAnimation = () => {
        setAnimationFramerate(ANIMATION_FRAMERATE)
        setEventActive(true);
    }
    useEffect (()=>{
        if (props.data.silentCrossing === false){
            props.audioController.playAudioByName("longLongShortLongHorn")
        }
    },[])
    
    useEffect (()=>{
        if (props.data.silentCrossing === false){
            const delta = Math.abs(props.zOffset - props.position) + 1
            let newVolume = 0.1 + Math.floor(100 / (delta/100))/100
            newVolume = newVolume > 1 ? 1 : newVolume
            props.audioController.setAudioVolumnByName("longLongShortLongHorn", newVolume)
        }
    },[props.position])

    return (
        <div className={`TrainEvent`}>
            <div className={`train-image`} style={styleObject} />
        </div>
    )
}

export default TrainEvent
